const POLICY_SYMBOL_REGEX = "^[A-Z]{3}$|^[A-Z]{2}$|^[A-Z]{1}$";
const POLICY_NUMBER_REGEX = "^[0-9]{7}$";
const DOCTYPE_POLICY_NUMBER_REGEX = "^[a-zA-Z0-9- ]+$";
const IDENTIFIER_REGEX = "^[a-z]{3}[0-9]{4}-[0-9]{3}[a-z0-9]{0,10}$"
const AGENCY_NUMBER_REGEX = "^[0-9]{7}$"
const BEACON_SYSTEM_POLICY_NUMBER_REGEX = "^[A-Z]{3} [0-9]{7}$";
const BONDS_POLICY_NUMBER_REGEX = "^SUR [0-9]{7}$";
const LOCATION_REGEX = "^[a-zA-Z0-9- ]+$"
const PATRONS_REGEX = "^[A-Z]{3} [0-9]{7}$|^[A-Z]{2}  [0-9]{7}$|^[A-Z]{1}   [0-9]{7}$"
const POLICY_INSURED_NAME_REGEX = "^.{1,29}$"
const PRODUCER_CODE_REGEX = "^[a-zA-Z0-9 ]+$"
const RTW_POLICY_NUMBER_REGEX = "^[A-Z]{2}-[A-Z]{2}-[0-9]{6}$"
const CHECK_RANGE_REGEX = "^([0-9]{10}|[0-9]{10}-[0-9]{10}) (EFT|DISB|PRRFD|CARD|GWPRF|RPRFD)"
const SSN_REGEX = "^[0-9]{3}-[0-9]{2}-[0-9]{4}$"
const PRODUCER_NUMBER_REGEX = "^[0-9]{1,7}$"
const USER_ID_REGEX = "^[a-zA-Z]{3}[0-9]{4}$"
const YEAR_REGEX = "^[0-9]{4}$"
const INTERNAL_AUDIT_USER_ID_REGEX = "^[a-zA-Z]{2,3}[0-9]{4}$"
const RHODE_POLICY_NUMBER_REGEX = "^R[0-9]{8}"
const checkcreditcardemployeenumber_ReGEX = "^[0-9]{6}$"

export function checkpolicySymbol(value) {
    return !(value.match(POLICY_SYMBOL_REGEX));
}
export function checkpolicyNumber(value) {
    return !(value.match(POLICY_NUMBER_REGEX));
}
export function checkIdentifier(value) {
    return !(value.match(IDENTIFIER_REGEX));
}
export function checkagencynumber(value) {
    return !(value.match(AGENCY_NUMBER_REGEX));
}
export function checkbeaconsystempolicynumber(value) {
    return !(value.match(BEACON_SYSTEM_POLICY_NUMBER_REGEX))
}
export function checkbondspolicynumber(value) {
    return !(value.match(BONDS_POLICY_NUMBER_REGEX));
}
export function checklocation(value) {
    return !(value.match(LOCATION_REGEX));
}
export function checkpatrons(value) {
    return !(value.match(PATRONS_REGEX));
}
export function checkpolicydeclineinsuredname(value) {
    return !(value.match(POLICY_INSURED_NAME_REGEX));
}
export function checkproducercode(value) {
    return !(value.match(PRODUCER_CODE_REGEX));
}
export function checkproducernumber(value) {
    return !(value.match(PRODUCER_NUMBER_REGEX));
}
export function checkrtwpolicynumber(value) {
    return !(value.match(RTW_POLICY_NUMBER_REGEX));
}
export function checkcheckrange(value) {
    return !(value.match(CHECK_RANGE_REGEX));
}
export function checkssn(value) {
    return !(value.match(SSN_REGEX));
}
export function checkuserID(value) {
    return !(value.match(USER_ID_REGEX));
}
export function checkyear(value) {
    return !(value.match(YEAR_REGEX));
}
export function checkinternalaudituserid(value) {
    return !(value.match(INTERNAL_AUDIT_USER_ID_REGEX));
}
export function checkrhodepolicynumber(value) {
    return !(value.match(RHODE_POLICY_NUMBER_REGEX));
}
export function checkcreditcardemployeenumber(value) {
    return !(value.match(checkcreditcardemployeenumber_ReGEX));
}
export function checkdoctypepolicynumber(value) {
    return !(value.match(DOCTYPE_POLICY_NUMBER_REGEX));
}